// 线路偏离预警 - Mock数据
// 坐标系说明：模拟使用WGS84经纬度，实际前端展示时按项目规范转换

const MOCK_ROUTES = [
  {
    id: 5001,
    name: '北京-天津 早班通勤线',
    code: 'RT-BJ-TJ-001',
    sourceType: 1, // 1-历史轨迹生成（唯一来源）
    sourceTypeText: '历史轨迹生成',
    sourceVehicleId: 100234,
    sourceVehiclePlate: '京A·12345',
    sourceTripId: 'TRIP202608010730001',
    pointCount: 246,
    totalLengthM: 128430.5,
    totalLengthKm: '128.4',
    extraPointCount: 3,
    bindingCount: 2,
    status: 1, // 0-草稿 1-启用 2-停用
    statusText: '已启用',
    version: 3,
    remark: '每日早班往返通勤线路，经京哈高速',
    createdBy: 1,
    createdAt: '2026-07-15 10:23:45',
    updatedAt: '2026-08-08 14:12:33',
    // 简化几何：北京到天津的一条示意折线
    geom: [
      [116.4074, 39.9042],
      [116.4521, 39.9201],
      [116.5203, 39.9512],
      [116.6015, 39.9755],
      [116.7021, 39.9910],
      [116.8200, 39.9680],
      [116.9503, 39.9012],
      [117.0520, 39.8250],
      [117.1305, 39.5201],
      [117.2015, 39.2300],
      [117.2210, 39.1350],
      [117.2005, 39.0842]
    ],
    bbox: [116.4074, 39.0842, 117.2210, 39.9910],
    // 附加点
    extraPoints: [
      { id: 1, routeId: 5001, pointType: 2, pointTypeText: '豁免点', name: '京哈高速田家府服务区加油站', category: 'GAS_STATION', lng: 116.7021, lat: 39.9910, radiusM: 200, seq: 0, remark: '早班必停加油点' },
      { id: 2, routeId: 5001, pointType: 2, pointTypeText: '豁免点', name: '武清服务区休息区', category: 'REST_AREA', lng: 117.0520, lat: 39.8250, radiusM: 250, seq: 0, remark: '' },
      { id: 3, routeId: 5001, pointType: 1, pointTypeText: '途经点', name: '天津北辰中转站', category: 'DEPOT', lng: 117.1305, lat: 39.5201, radiusM: 0, seq: 1, remark: '必须经停装卸货' }
    ],
    genParams: { dpTolerance: 8, enableMapMatch: true, compressStay: true }
  },
  {
    id: 5002,
    name: '上海虹桥-浦东机场 班车线',
    code: 'RT-SH-HQ-PD-002',
    sourceType: 1,
    sourceTypeText: '历史轨迹生成',
    sourceVehicleId: 100254,
    sourceVehiclePlate: '沪A·P1001',
    sourceTripId: 'TRIP202607220600001',
    pointCount: 87,
    totalLengthM: 58200.0,
    totalLengthKm: '58.2',
    extraPointCount: 2,
    bindingCount: 1,
    status: 1,
    statusText: '已启用',
    version: 1,
    remark: '员工班车线路',
    createdAt: '2026-07-22 09:12:00',
    updatedAt: '2026-07-22 09:12:00',
    geom: [
      [121.3200, 31.1940],
      [121.4200, 31.2000],
      [121.5200, 31.2200],
      [121.6200, 31.2000],
      [121.7200, 31.1800],
      [121.8050, 31.1443]
    ],
    bbox: [121.3200, 31.1443, 121.8050, 31.2200],
    extraPoints: [
      { id: 4, routeId: 5002, pointType: 2, pointTypeText: '豁免点', name: '龙阳路地铁站', category: 'CUSTOM', lng: 121.5500, lat: 31.2100, radiusM: 150, seq: 0, remark: '上客点' }
    ],
    genParams: { dpTolerance: 5, enableMapMatch: true }
  },
  {
    id: 5003,
    name: '深圳市区-盐田港 冷链配送',
    code: 'RT-SZ-YT-003',
    sourceType: 1,
    sourceTypeText: '历史轨迹生成',
    sourceVehicleId: 100456,
    sourceVehiclePlate: '粤B·88888',
    pointCount: 312,
    totalLengthM: 45600.0,
    totalLengthKm: '45.6',
    extraPointCount: 1,
    bindingCount: 3,
    status: 2,
    statusText: '已停用',
    version: 2,
    remark: '冷链固定配送线路（临时停用调整中）',
    createdAt: '2026-06-30 16:40:10',
    updatedAt: '2026-08-01 11:00:00',
    geom: [
      [114.0850, 22.5470],
      [114.1500, 22.5600],
      [114.2300, 22.5800],
      [114.3100, 22.5900],
      [114.3800, 22.6000],
      [114.4200, 22.5700],
      [114.4600, 22.5400]
    ],
    bbox: [114.0850, 22.5400, 114.4600, 22.6000],
    extraPoints: [
      { id: 5, routeId: 5003, pointType: 1, pointTypeText: '途经点', name: '罗湖笋岗冷库', category: 'DEPOT', lng: 114.1200, lat: 22.5550, radiusM: 0, seq: 1, remark: '装货点' }
    ],
    genParams: { dpTolerance: 6, enableMapMatch: true }
  },
  {
    id: 5004,
    name: '杭州城区-萧山机场 行政用车',
    code: 'RT-HZ-XS-004',
    sourceType: 1,
    sourceTypeText: '历史轨迹生成',
    sourceVehicleId: 100262,
    sourceVehiclePlate: '浙A·X7001',
    sourceTripId: 'TRIP202608090800001',
    pointCount: 156,
    totalLengthM: 32100.0,
    totalLengthKm: '32.1',
    extraPointCount: 0,
    bindingCount: 0,
    status: 0,
    statusText: '草稿',
    version: 1,
    remark: '草稿，待人工审核',
    createdAt: '2026-08-09 17:30:00',
    updatedAt: '2026-08-09 17:30:00',
    geom: [
      [120.1550, 30.2740],
      [120.2500, 30.3000],
      [120.3500, 30.3200],
      [120.4320, 30.2360]
    ],
    bbox: [120.1550, 30.2360, 120.4320, 30.3200],
    extraPoints: [],
    genParams: { dpTolerance: 10, enableMapMatch: false }
  }
];

const MOCK_BINDINGS = [
  {
    id: 8001,
    name: '早班通勤线监控（一车队）',
    routeId: 5001,
    routeName: '北京-天津 早班通勤线',
    vehicleCount: 12,
    vehicles: [
      { vehicleId: 100234, plateNo: '京A·12345', driver: '张伟', driverPhone: '138****6789' },
      { vehicleId: 100235, plateNo: '京A·12346', driver: '李强', driverPhone: '139****1234' },
      { vehicleId: 100236, plateNo: '京A·12347', driver: '王芳', driverPhone: '137****5678' },
      { vehicleId: 100237, plateNo: '京A·12348', driver: '刘洋', driverPhone: '136****9012' },
      { vehicleId: 100238, plateNo: '京A·12349', driver: '陈静', driverPhone: '135****3456' },
      { vehicleId: 100239, plateNo: '京A·12350', driver: '杨帆', driverPhone: '134****7890' },
      { vehicleId: 100240, plateNo: '京A·12351', driver: '赵磊', driverPhone: '133****2345' },
      { vehicleId: 100241, plateNo: '京A·12352', driver: '孙悦', driverPhone: '132****6789' },
      { vehicleId: 100242, plateNo: '京A·12353', driver: '周杰', driverPhone: '131****0123' },
      { vehicleId: 100243, plateNo: '京A·12354', driver: '吴敏', driverPhone: '130****4567' },
      { vehicleId: 100244, plateNo: '京A·12355', driver: '郑浩', driverPhone: '158****8901' },
      { vehicleId: 100245, plateNo: '京A·12356', driver: '黄磊', driverPhone: '159****2345' }
    ],
    thresholdM: 300,
    recoverThresholdM: 240,
    triggerPointCount: 3,
    triggerDurationS: 60,
    triggerDistanceM: 0,
    recoverPointCount: 3,
    onlyWhenMoving: true,
    minSpeedKmh: 5,
    effectiveType: 2, // 1-单次 2-周期
    effectiveTypeText: '周期',
    validFrom: '2026-08-01',
    validTo: '2026-12-31',
    weekdayMask: 31, // bit0-4: 周一至周五
    weekdays: [1, 2, 3, 4, 5],
    weekdaysText: '周一至周五',
    dailySlots: [
      { start: '07:30', end: '09:00' },
      { start: '17:00', end: '19:30' }
    ],
    dailySlotsText: '07:30-09:00, 17:00-19:30',
    timezone: 'Asia/Shanghai',
    alarmLevel: 2, // 1-提示 2-重要 3-紧急
    alarmLevelText: '重要',
    notifyChannels: ['INAPP', 'SMS'],
    notifyChannelsText: '站内信, 短信',
    notifyReceivers: [
      { type: 'ROLE', id: 12, name: '调度组' },
      { type: 'USER', id: 3301, name: '王主管' }
    ],
    notifyReceiversText: '调度组, 王主管',
    silenceMinutes: 10,
    repeatNotifyMinutes: 0,
    notifyOnRecover: true,
    status: 1,
    statusText: '启用中',
    createdBy: 1,
    createdAt: '2026-07-20 10:00:00',
    updatedAt: '2026-08-05 16:30:00',
    conflictInfo: null
  },
  {
    id: 8002,
    name: '早班通勤线监控（二车队）',
    routeId: 5001,
    routeName: '北京-天津 早班通勤线',
    vehicleCount: 8,
    vehicles: [
      { vehicleId: 100301, plateNo: '京B·90001', driver: '马超', driverPhone: '186****1111' },
      { vehicleId: 100302, plateNo: '京B·90002', driver: '胡歌', driverPhone: '187****2222' },
      { vehicleId: 100303, plateNo: '京B·90003', driver: '林俊', driverPhone: '188****3333' },
      { vehicleId: 100304, plateNo: '京B·90004', driver: '何静', driverPhone: '189****4444' },
      { vehicleId: 100305, plateNo: '京B·90005', driver: '高远', driverPhone: '185****5555' },
      { vehicleId: 100306, plateNo: '京B·90006', driver: '宋佳', driverPhone: '184****6666' },
      { vehicleId: 100307, plateNo: '京B·90007', driver: '唐嫣', driverPhone: '183****7777' },
      { vehicleId: 100308, plateNo: '京B·90008', driver: '董璇', driverPhone: '182****8888' }
    ],
    thresholdM: 400,
    recoverThresholdM: 320,
    triggerPointCount: 4,
    triggerDurationS: 90,
    triggerDistanceM: 500,
    recoverPointCount: 3,
    onlyWhenMoving: true,
    minSpeedKmh: 5,
    effectiveType: 2,
    effectiveTypeText: '周期',
    validFrom: '2026-08-05',
    validTo: '2027-02-28',
    weekdayMask: 62, // 周二至周六
    weekdays: [2, 3, 4, 5, 6],
    weekdaysText: '周二至周六',
    dailySlots: [
      { start: '06:30', end: '08:30' }
    ],
    dailySlotsText: '06:30-08:30',
    timezone: 'Asia/Shanghai',
    alarmLevel: 1,
    alarmLevelText: '提示',
    notifyChannels: ['INAPP'],
    notifyChannelsText: '站内信',
    notifyReceivers: [
      { type: 'ROLE', id: 13, name: '二车队调度' }
    ],
    notifyReceiversText: '二车队调度',
    silenceMinutes: 15,
    repeatNotifyMinutes: 30,
    notifyOnRecover: false,
    status: 1,
    statusText: '启用中',
    createdAt: '2026-08-01 14:20:00',
    updatedAt: '2026-08-01 14:20:00'
  },
  {
    id: 8003,
    name: '上海虹桥-浦东机场班车',
    routeId: 5002,
    routeName: '上海虹桥-浦东机场 班车线',
    vehicleCount: 5,
    vehicles: [
      { vehicleId: 100501, plateNo: '沪A·P1001', driver: '徐峥', driverPhone: '176****0001' },
      { vehicleId: 100502, plateNo: '沪A·P1002', driver: '王宝强', driverPhone: '177****0002' },
      { vehicleId: 100503, plateNo: '沪A·P1003', driver: '黄渤', driverPhone: '178****0003' },
      { vehicleId: 100504, plateNo: '沪A·P1004', driver: '沈腾', driverPhone: '179****0004' },
      { vehicleId: 100505, plateNo: '沪A·P1005', driver: '贾玲', driverPhone: '175****0005' }
    ],
    thresholdM: 250,
    recoverThresholdM: 200,
    triggerPointCount: 3,
    triggerDurationS: 60,
    triggerDistanceM: 0,
    recoverPointCount: 3,
    onlyWhenMoving: true,
    minSpeedKmh: 5,
    effectiveType: 2,
    effectiveTypeText: '周期',
    validFrom: '2026-07-25',
    validTo: '2026-12-31',
    weekdayMask: 127, // 每天
    weekdays: [1, 2, 3, 4, 5, 6, 7],
    weekdaysText: '每日',
    dailySlots: [
      { start: '05:00', end: '23:00' }
    ],
    dailySlotsText: '05:00-23:00',
    timezone: 'Asia/Shanghai',
    alarmLevel: 3,
    alarmLevelText: '紧急',
    notifyChannels: ['INAPP', 'SMS', 'PUSH'],
    notifyChannelsText: '站内信, 短信, APP推送',
    notifyReceivers: [
      { type: 'ROLE', id: 14, name: '上海调度中心' },
      { type: 'USER', id: 4102, name: '车队长李哥' }
    ],
    notifyReceiversText: '上海调度中心, 车队长李哥',
    silenceMinutes: 8,
    repeatNotifyMinutes: 15,
    notifyOnRecover: true,
    status: 1,
    statusText: '启用中',
    createdAt: '2026-07-23 09:00:00',
    updatedAt: '2026-08-06 10:15:00'
  },
  {
    id: 8004,
    name: '深圳-盐田冷链专线（临时专项）',
    routeId: 5003,
    routeName: '深圳市区-盐田港 冷链配送',
    vehicleCount: 3,
    vehicles: [
      { vehicleId: 100601, plateNo: '粤B·C2001', driver: '张译', driverPhone: '166****7001' },
      { vehicleId: 100602, plateNo: '粤B·C2002', driver: '段奕宏', driverPhone: '167****7002' },
      { vehicleId: 100603, plateNo: '粤B·C2003', driver: '张涵予', driverPhone: '168****7003' }
    ],
    thresholdM: 300,
    recoverThresholdM: 240,
    triggerPointCount: 3,
    triggerDurationS: 60,
    triggerDistanceM: 0,
    recoverPointCount: 3,
    onlyWhenMoving: true,
    minSpeedKmh: 5,
    effectiveType: 1,
    effectiveTypeText: '单次',
    validFrom: '2026-08-10 06:00',
    validTo: '2026-08-20 22:00',
    weekdayMask: 0,
    weekdays: [],
    weekdaysText: '—',
    dailySlots: [],
    dailySlotsText: '全程生效',
    timezone: 'Asia/Shanghai',
    alarmLevel: 2,
    alarmLevelText: '重要',
    notifyChannels: ['INAPP', 'SMS'],
    notifyChannelsText: '站内信, 短信',
    notifyReceivers: [
      { type: 'ROLE', id: 15, name: '冷链调度组' }
    ],
    notifyReceiversText: '冷链调度组',
    silenceMinutes: 10,
    repeatNotifyMinutes: 0,
    notifyOnRecover: true,
    status: 0,
    statusText: '已停用',
    createdAt: '2026-08-01 11:30:00',
    updatedAt: '2026-08-09 18:00:00'
  }
];

const now = Date.now();
const minAgo = (m) => new Date(now - m * 60 * 1000);
const hourAgo = (h) => new Date(now - h * 3600 * 1000);
const dayAgo = (d) => new Date(now - d * 86400 * 1000);
const fmtTime = (d) => {
  const dt = (d instanceof Date) ? d : new Date(d);
  const p = (n) => n.toString().padStart(2, '0');
  return `${dt.getFullYear()}-${p(dt.getMonth() + 1)}-${p(dt.getDate())} ${p(dt.getHours())}:${p(dt.getMinutes())}:${p(dt.getSeconds())}`;
};

const MOCK_EVENTS = [
  {
    id: 90001,
    bindingId: 8001,
    routeId: 5001,
    routeName: '北京-天津 早班通勤线',
    routeVersion: 3,
    vehicleId: 100235,
    plateNo: '京A·12346',
    driverId: 2001,
    driverName: '李强',
    driverPhone: '139****1234',
    startTime: fmtTime(hourAgo(1.5)),
    triggerTime: fmtTime(hourAgo(1.4)),
    endTime: fmtTime(hourAgo(0.8)),
    durationS: 2520,
    durationText: '42分钟',
    thresholdM: 300,
    maxDeviationM: 687.5,
    maxDeviationText: '687.5 米',
    avgDeviationM: 412.3,
    offRouteMileageM: 8450,
    offRouteMileageText: '8.45 公里',
    startLng: 116.7021, startLat: 39.9910,
    maxLng: 116.6600, maxLat: 39.9500,
    endLng: 116.6950, endLat: 39.9820,
    startAddress: '京哈高速田家府服务区附近',
    maxAddress: '北京市通州区于家务乡XX村',
    endAddress: '京哈高速K58公里处',
    eventStatus: 2, // 1-进行中 2-已回归 3-窗口结束关闭 4-超时关闭
    eventStatusText: '已回归',
    closeReason: 'RECOVERED',
    closeReasonText: '车辆回归线路',
    handleStatus: 2, // 0-未处理 1-处理中 2-已处理 3-已忽略 4-误报
    handleStatusText: '已处理',
    handlerId: 1,
    handlerName: '王主管',
    handleTime: fmtTime(hourAgo(0.5)),
    handleRemark: '司机因临时事故绕行，已电话确认，建议下不为例',
    isBackfill: false,
    alarmLevel: 2,
    alarmLevelText: '重要',
    createdAt: fmtTime(hourAgo(1.4)),
    updatedAt: fmtTime(hourAgo(0.5))
  },
  {
    id: 90002,
    bindingId: 8001,
    routeId: 5001,
    routeName: '北京-天津 早班通勤线',
    routeVersion: 3,
    vehicleId: 100240,
    plateNo: '京A·12351',
    driverId: 2007,
    driverName: '赵磊',
    driverPhone: '133****2345',
    startTime: fmtTime(minAgo(25)),
    triggerTime: fmtTime(minAgo(22)),
    endTime: null,
    durationS: 1500,
    durationText: '25分钟（持续中）',
    thresholdM: 300,
    maxDeviationM: 512.8,
    maxDeviationText: '512.8 米',
    avgDeviationM: 388.0,
    offRouteMileageM: 4200,
    offRouteMileageText: '4.20 公里',
    startLng: 116.9503, startLat: 39.9012,
    maxLng: 116.9900, maxLat: 39.8500,
    endLng: null, endLat: null,
    startAddress: '京哈高速K45公里处',
    maxAddress: '天津市武清区曹子里镇',
    endAddress: null,
    eventStatus: 1,
    eventStatusText: '进行中',
    closeReason: null,
    closeReasonText: null,
    handleStatus: 1,
    handleStatusText: '处理中',
    handlerId: 1,
    handlerName: '王主管',
    handleTime: fmtTime(minAgo(15)),
    handleRemark: '正在联系司机核实原因...',
    isBackfill: false,
    alarmLevel: 2,
    alarmLevelText: '重要',
    createdAt: fmtTime(minAgo(22)),
    updatedAt: fmtTime(minAgo(5))
  },
  {
    id: 90003,
    bindingId: 8003,
    routeId: 5002,
    routeName: '上海虹桥-浦东机场 班车线',
    routeVersion: 1,
    vehicleId: 100503,
    plateNo: '沪A·P1003',
    driverId: 3003,
    driverName: '黄渤',
    driverPhone: '178****0003',
    startTime: fmtTime(hourAgo(3.2)),
    triggerTime: fmtTime(hourAgo(3.1)),
    endTime: fmtTime(hourAgo(2.8)),
    durationS: 180,
    durationText: '3分钟',
    thresholdM: 250,
    maxDeviationM: 285.0,
    maxDeviationText: '285.0 米',
    avgDeviationM: 265.0,
    offRouteMileageM: 620,
    offRouteMileageText: '0.62 公里',
    startLng: 121.5500, startLat: 31.2100,
    maxLng: 121.5600, maxLat: 31.2050,
    endLng: 121.5520, endLat: 31.2095,
    startAddress: '龙阳路地铁站附近',
    maxAddress: '上海浦东新区白杨路',
    endAddress: '龙阳路地铁站附近',
    eventStatus: 2,
    eventStatusText: '已回归',
    closeReason: 'RECOVERED',
    closeReasonText: '车辆回归线路',
    handleStatus: 4,
    handleStatusText: '误报',
    handlerId: 2,
    handlerName: '车队长李哥',
    handleTime: fmtTime(hourAgo(2.5)),
    handleRemark: '龙阳路地铁站施工，临时绕行白杨路，误报。已将白杨路附近加为豁免点候选。',
    isBackfill: false,
    alarmLevel: 3,
    alarmLevelText: '紧急',
    createdAt: fmtTime(hourAgo(3.1)),
    updatedAt: fmtTime(hourAgo(2.5))
  },
  {
    id: 90004,
    bindingId: 8001,
    routeId: 5001,
    routeName: '北京-天津 早班通勤线',
    routeVersion: 2,
    vehicleId: 100238,
    plateNo: '京A·12349',
    driverId: 2005,
    driverName: '陈静',
    driverPhone: '135****3456',
    startTime: fmtTime(dayAgo(1)),
    triggerTime: fmtTime(dayAgo(1) + 60 * 1000),
    endTime: fmtTime(dayAgo(1) + 35 * 60 * 1000),
    durationS: 2040,
    durationText: '34分钟',
    thresholdM: 300,
    maxDeviationM: 420.0,
    maxDeviationText: '420.0 米',
    avgDeviationM: 320.0,
    offRouteMileageM: 5100,
    offRouteMileageText: '5.10 公里',
    startLng: 116.6015, startLat: 39.9755,
    maxLng: 116.5700, maxLat: 39.9400,
    endLng: 116.5950, endLat: 39.9720,
    startAddress: '京哈高速香河出口附近',
    maxAddress: '河北香河环保产业园',
    endAddress: '京哈高速K30公里处',
    eventStatus: 2,
    eventStatusText: '已回归',
    closeReason: 'RECOVERED',
    closeReasonText: '车辆回归线路',
    handleStatus: 2,
    handleStatusText: '已处理',
    handlerId: 1,
    handlerName: '王主管',
    handleTime: fmtTime(dayAgo(1) + 45 * 60 * 1000),
    handleRemark: '司机私自绕路回家取物品，已批评教育并罚款。',
    isBackfill: false,
    alarmLevel: 2,
    alarmLevelText: '重要',
    createdAt: fmtTime(dayAgo(1) + 60 * 1000),
    updatedAt: fmtTime(dayAgo(1) + 45 * 60 * 1000)
  },
  {
    id: 90005,
    bindingId: 8002,
    routeId: 5001,
    routeName: '北京-天津 早班通勤线',
    routeVersion: 3,
    vehicleId: 100305,
    plateNo: '京B·90005',
    driverId: 2015,
    driverName: '高远',
    driverPhone: '185****5555',
    startTime: fmtTime(minAgo(8)),
    triggerTime: fmtTime(minAgo(5)),
    endTime: null,
    durationS: 480,
    durationText: '8分钟（持续中）',
    thresholdM: 400,
    maxDeviationM: 1250.3,
    maxDeviationText: '1250.3 米',
    avgDeviationM: 950.0,
    offRouteMileageM: 3200,
    offRouteMileageText: '3.20 公里',
    startLng: 117.0520, startLat: 39.8250,
    maxLng: 117.1200, maxLat: 39.7800,
    endLng: null, endLat: null,
    startAddress: '武清服务区附近',
    maxAddress: '天津市武清区大王古庄镇',
    endAddress: null,
    eventStatus: 1,
    eventStatusText: '进行中',
    closeReason: null,
    closeReasonText: null,
    handleStatus: 0,
    handleStatusText: '未处理',
    handlerId: null,
    handlerName: null,
    handleTime: null,
    handleRemark: null,
    isBackfill: false,
    alarmLevel: 3,
    alarmLevelText: '紧急',
    createdAt: fmtTime(minAgo(5)),
    updatedAt: fmtTime(minAgo(1))
  },
  {
    id: 90006,
    bindingId: 8004,
    routeId: 5003,
    routeName: '深圳市区-盐田港 冷链配送',
    routeVersion: 2,
    vehicleId: 100602,
    plateNo: '粤B·C2002',
    driverId: 4002,
    driverName: '段奕宏',
    driverPhone: '167****7002',
    startTime: fmtTime(dayAgo(2)),
    triggerTime: fmtTime(dayAgo(2) + 120 * 1000),
    endTime: fmtTime(dayAgo(2) + 8 * 3600 * 1000),
    durationS: 28080,
    durationText: '7小时48分',
    thresholdM: 300,
    maxDeviationM: 3120.0,
    maxDeviationText: '3.12 公里',
    avgDeviationM: 1450.0,
    offRouteMileageM: 42300,
    offRouteMileageText: '42.30 公里',
    startLng: 114.1500, startLat: 22.5600,
    maxLng: 114.3000, maxLat: 22.7500,
    endLng: 114.4600, endLat: 22.5400,
    startAddress: '罗湖笋岗冷库附近',
    maxAddress: '深圳市龙岗区平湖街道',
    endAddress: '盐田港港区',
    eventStatus: 3,
    eventStatusText: '窗口结束关闭',
    closeReason: 'WINDOW_END',
    closeReasonText: '任务时间窗结束',
    handleStatus: 2,
    handleStatusText: '已处理',
    handlerId: 3,
    handlerName: '冷链调度组',
    handleTime: fmtTime(dayAgo(2) + 9 * 3600 * 1000),
    handleRemark: '司机严重偏离，私自去龙岗区私活，已上报公司，按合同处理。',
    isBackfill: false,
    alarmLevel: 3,
    alarmLevelText: '紧急',
    createdAt: fmtTime(dayAgo(2) + 120 * 1000),
    updatedAt: fmtTime(dayAgo(2) + 9 * 3600 * 1000)
  }
];

const MOCK_VEHICLES_POOL = (function() {
  const plates = [
    ['京A·12345', '张伟', '138****6789'], ['京A·12346', '李强', '139****1234'], ['京A·12347', '王芳', '137****5678'],
    ['京A·12348', '刘洋', '136****9012'], ['京A·12349', '陈静', '135****3456'], ['京A·12350', '杨帆', '134****7890'],
    ['京A·12351', '赵磊', '133****2345'], ['京A·12352', '孙悦', '132****6789'], ['京A·12353', '周杰', '131****0123'],
    ['京A·12354', '吴敏', '130****4567'], ['京A·12355', '郑浩', '158****8901'], ['京A·12356', '黄磊', '159****2345'],
    ['京B·90001', '马超', '186****1111'], ['京B·90002', '胡歌', '187****2222'], ['京B·90003', '林俊', '188****3333'],
    ['京B·90004', '何静', '189****4444'], ['京B·90005', '高远', '185****5555'], ['京B·90006', '宋佳', '184****6666'],
    ['京B·90007', '唐嫣', '183****7777'], ['京B·90008', '董璇', '182****8888'],
    ['沪A·P1001', '徐峥', '176****0001'], ['沪A·P1002', '王宝强', '177****0002'], ['沪A·P1003', '黄渤', '178****0003'],
    ['沪A·P1004', '沈腾', '179****0004'], ['沪A·P1005', '贾玲', '175****0005'],
    ['粤B·C2001', '张译', '166****7001'], ['粤B·C2002', '段奕宏', '167****7002'], ['粤B·C2003', '张涵予', '168****7003'],
    ['浙A·X7001', '马云', '155****8001'], ['浙A·X7002', '丁磊', '156****8002'], ['浙A·X7003', '宗庆后', '157****8003']
  ];
  return plates.map((p, i) => ({
    vehicleId: 100234 + i,
    plateNo: p[0],
    driver: p[1],
    driverPhone: p[2],
    company: i < 20 ? '北京一运车队' : (i < 25 ? '上海浦东运输公司' : (i < 28 ? '深圳冷链物流' : '杭州行政车队')),
    group: i < 12 ? '一车队' : (i < 20 ? '二车队' : (i < 25 ? '上海班车部' : (i < 28 ? '冷链部' : '杭州行政部'))),
    vehicleType: (i % 3 === 0) ? '大巴' : (i % 3 === 1 ? '货车' : '商务车'),
    enabled: true
  }));
})();

// ---------- Mock API ----------

function delay(data, ms = 300) {
  return new Promise(resolve => setTimeout(() => resolve(data), ms));
}

function paginate(list, { page = 1, pageSize = 10, keyword = '', extraFilter } = {}) {
  let arr = list.slice();
  if (keyword) {
    const kw = keyword.toLowerCase();
    arr = arr.filter(item => {
      const s = JSON.stringify(item).toLowerCase();
      return s.includes(kw);
    });
  }
  if (typeof extraFilter === 'function') arr = arr.filter(extraFilter);
  const total = arr.length;
  const start = (page - 1) * pageSize;
  const data = arr.slice(start, start + pageSize);
  return { code: 200, data, total, recordsTotal: total };
}

// Routes
export function mockGetRoutes(params) {
  const { status } = params || {};
  return delay(paginate(MOCK_ROUTES, {
    ...params,
    extraFilter: (r) => (status == null || String(r.status) === String(status))
  }));
}

export function mockGetRouteDetail(id) {
  const r = MOCK_ROUTES.find(x => x.id == id);
  return delay({ code: 200, data: r ? JSON.parse(JSON.stringify(r)) : null });
}

export function mockSaveRoute(route) {
  const now = new Date();
  const ts = `${now.getFullYear()}-${String(now.getMonth()+1).padStart(2,'0')}-${String(now.getDate()).padStart(2,'0')} ${String(now.getHours()).padStart(2,'0')}:${String(now.getMinutes()).padStart(2,'0')}:${String(now.getSeconds()).padStart(2,'0')}`;
  if (route.id) {
    const idx = MOCK_ROUTES.findIndex(r => r.id === route.id);
    if (idx >= 0) {
      MOCK_ROUTES[idx] = { ...MOCK_ROUTES[idx], ...route, version: MOCK_ROUTES[idx].version + 1, updatedAt: ts };
    }
  } else {
    route.id = 5100 + MOCK_ROUTES.length;
    route.createdAt = ts;
    route.updatedAt = ts;
    route.version = 1;
    route.status = route.status ?? 1;
    route.bindingCount = 0;
    MOCK_ROUTES.unshift(route);
  }
  return delay({ code: 200, data: route });
}

export function mockDeleteRoute(id) {
  const idx = MOCK_ROUTES.findIndex(r => r.id == id);
  if (idx >= 0) MOCK_ROUTES.splice(idx, 1);
  return delay({ code: 200 });
}

export function mockCopyRoute(id) {
  const r = MOCK_ROUTES.find(x => x.id == id);
  if (!r) return delay({ code: 404, msg: 'not found' });
  const now = new Date();
  const ts = `${now.getFullYear()}-${String(now.getMonth()+1).padStart(2,'0')}-${String(now.getDate()).padStart(2,'0')} ${String(now.getHours()).padStart(2,'0')}:${String(now.getMinutes()).padStart(2,'0')}:${String(now.getSeconds()).padStart(2,'0')}`;
  const copy = JSON.parse(JSON.stringify(r));
  copy.id = 5100 + MOCK_ROUTES.length + Math.floor(Math.random() * 100);
  copy.name = copy.name + ' (副本)';
  copy.status = 0;
  copy.statusText = '草稿';
  copy.bindingCount = 0;
  copy.createdAt = ts;
  copy.updatedAt = ts;
  copy.version = 1;
  MOCK_ROUTES.unshift(copy);
  return delay({ code: 200, data: copy });
}

export function mockToggleRouteStatus(id, status) {
  const r = MOCK_ROUTES.find(x => x.id == id);
  if (r) {
    r.status = status;
    r.statusText = status === 1 ? '已启用' : (status === 2 ? '已停用' : '草稿');
  }
  return delay({ code: 200 });
}

// Bindings
export function mockGetBindings(params) {
  const { status, routeId } = params || {};
  return delay(paginate(MOCK_BINDINGS, {
    ...params,
    extraFilter: (b) => {
      if (status != null && String(b.status) !== String(status)) return false;
      if (routeId != null && String(b.routeId) !== String(routeId)) return false;
      return true;
    }
  }));
}

export function mockGetBindingDetail(id) {
  const b = MOCK_BINDINGS.find(x => x.id == id);
  return delay({ code: 200, data: b ? JSON.parse(JSON.stringify(b)) : null });
}

export function mockSaveBinding(binding) {
  const now = new Date();
  const ts = `${now.getFullYear()}-${String(now.getMonth()+1).padStart(2,'0')}-${String(now.getDate()).padStart(2,'0')} ${String(now.getHours()).padStart(2,'0')}:${String(now.getMinutes()).padStart(2,'0')}:${String(now.getSeconds()).padStart(2,'0')}`;
  if (binding.id) {
    const idx = MOCK_BINDINGS.findIndex(b => b.id === binding.id);
    if (idx >= 0) {
      MOCK_BINDINGS[idx] = { ...MOCK_BINDINGS[idx], ...binding, updatedAt: ts };
    }
  } else {
    binding.id = 8100 + MOCK_BINDINGS.length;
    binding.createdAt = ts;
    binding.updatedAt = ts;
    binding.status = binding.status ?? 1;
    MOCK_BINDINGS.unshift(binding);
    // 同步线路的bindingCount
    const r = MOCK_ROUTES.find(x => x.id === binding.routeId);
    if (r) r.bindingCount = (r.bindingCount || 0) + 1;
  }
  return delay({ code: 200, data: binding });
}

export function mockDeleteBinding(id) {
  const idx = MOCK_BINDINGS.findIndex(b => b.id == id);
  if (idx >= 0) {
    const b = MOCK_BINDINGS[idx];
    MOCK_BINDINGS.splice(idx, 1);
    const r = MOCK_ROUTES.find(x => x.id === b.routeId);
    if (r) r.bindingCount = Math.max(0, (r.bindingCount || 0) - 1);
  }
  return delay({ code: 200 });
}

export function mockToggleBindingStatus(id, status) {
  const b = MOCK_BINDINGS.find(x => x.id == id);
  if (b) {
    b.status = status;
    b.statusText = status === 1 ? '启用中' : '已停用';
  }
  return delay({ code: 200 });
}

export function mockCheckBindingConflict({ vehicleIds, bindingId, validFrom, validTo }) {
  // 返回时间窗重叠的车辆
  const conflicts = [];
  for (const b of MOCK_BINDINGS) {
    if (bindingId && b.id == bindingId) continue;
    if (b.status !== 1) continue;
    for (const v of b.vehicles || []) {
      if (vehicleIds.includes(v.vehicleId)) {
        conflicts.push({
          vehicleId: v.vehicleId,
          plateNo: v.plateNo,
          bindingId: b.id,
          bindingName: b.name,
          overlapReason: `已绑定任务「${b.name}」（${b.weekdaysText || ''} ${b.dailySlotsText || ''}）`
        });
      }
    }
  }
  return delay({ code: 200, data: conflicts });
}

// Vehicles pool
export function mockGetVehicles(params) {
  return delay(paginate(MOCK_VEHICLES_POOL, params));
}

export function mockGetVehicleGroups() {
  const groups = Array.from(new Set(MOCK_VEHICLES_POOL.map(v => v.group))).map(name => ({
    id: 'G_' + name,
    name,
    count: MOCK_VEHICLES_POOL.filter(v => v.group === name).length
  }));
  return delay({ code: 200, data: groups });
}

// Deviation events
export function mockGetEvents(params) {
  const { eventStatus, handleStatus, vehicleId, routeId, startTime, endTime } = params || {};
  return delay(paginate(MOCK_EVENTS, {
    ...params,
    extraFilter: (e) => {
      if (eventStatus != null && String(e.eventStatus) !== String(eventStatus)) return false;
      if (handleStatus != null && String(e.handleStatus) !== String(handleStatus)) return false;
      if (vehicleId != null && String(e.vehicleId) !== String(vehicleId)) return false;
      if (routeId != null && String(e.routeId) !== String(routeId)) return false;
      return true;
    }
  }));
}

export function mockGetEventDetail(id) {
  const e = MOCK_EVENTS.find(x => x.id == id);
  return delay({ code: 200, data: e ? JSON.parse(JSON.stringify(e)) : null });
}

// 回放轨迹：基准线+实际轨迹+逐点偏离距离
export function mockGetEventReplay(id) {
  const e = MOCK_EVENTS.find(x => x.id == id);
  if (!e) return delay({ code: 404 });
  const route = MOCK_ROUTES.find(r => r.id === e.routeId);
  const baseGeom = route ? route.geom : [];
  // 生成实际轨迹：把基准线的点每个都做一点偏移模拟偏离
  const actualTrack = baseGeom.map((p, i) => {
    const t = i / Math.max(1, baseGeom.length - 1);
    // 偏离形状：中间段偏移最大，两端接近基准
    const bell = Math.sin(t * Math.PI);
    const off = (e.maxDeviationM / 111000.0) * bell * (0.7 + 0.3 * Math.sin(i * 0.7));
    return {
      t: i * 30, // 秒
      lng: p[0] + off * 1.2,
      lat: p[1] - off * 0.8,
      spd: 30 + Math.floor(Math.random() * 50),
      dev: Math.floor(100 + bell * (e.maxDeviationM - 100))
    };
  });
  return delay({
    code: 200,
    data: {
      eventId: e.id,
      route: baseGeom,
      startPoint: [e.startLng, e.startLat],
      maxPoint: [e.maxLng, e.maxLat],
      endPoint: e.endLng ? [e.endLng, e.endLat] : null,
      actualTrack,
      thresholdM: e.thresholdM
    }
  });
}

export function mockHandleEvent({ id, handleStatus, handleRemark, handlerId, handlerName }) {
  const e = MOCK_EVENTS.find(x => x.id == id);
  if (e) {
    const now = new Date();
    const ts = `${now.getFullYear()}-${String(now.getMonth()+1).padStart(2,'0')}-${String(now.getDate()).padStart(2,'0')} ${String(now.getHours()).padStart(2,'0')}:${String(now.getMinutes()).padStart(2,'0')}:${String(now.getSeconds()).padStart(2,'0')}`;
    e.handleStatus = handleStatus;
    const map = { 0: '未处理', 1: '处理中', 2: '已处理', 3: '已忽略', 4: '误报' };
    e.handleStatusText = map[handleStatus] || e.handleStatusText;
    e.handleTime = ts;
    if (handlerId != null) e.handlerId = handlerId;
    if (handlerName) e.handlerName = handlerName;
    if (handleRemark != null) e.handleRemark = handleRemark;
  }
  return delay({ code: 200 });
}

export function mockAddExemptPoint({ id, routeId, name, lng, lat, radiusM }) {
  const route = MOCK_ROUTES.find(r => r.id === routeId);
  if (!route) return delay({ code: 404 });
  const newPoint = {
    id: 100 + (route.extraPoints || []).length,
    routeId,
    pointType: 2,
    pointTypeText: '豁免点',
    name: name || '从告警添加的豁免点',
    category: 'CUSTOM',
    lng, lat,
    radiusM: radiusM || 200,
    seq: 0,
    remark: `由偏离事件 #${id} 一键添加`
  };
  route.extraPoints = route.extraPoints || [];
  route.extraPoints.push(newPoint);
  route.extraPointCount = route.extraPoints.length;
  return delay({ code: 200, data: newPoint });
}

export function mockGetEventStatistics() {
  // 过去7天的趋势
  const trend = [];
  const today = new Date();
  for (let i = 6; i >= 0; i--) {
    const d = new Date(today.getTime() - i * 86400000);
    const key = `${d.getMonth()+1}-${d.getDate()}`;
    trend.push({
      date: key,
      total: 5 + Math.floor(Math.random() * 10),
      ongoing: Math.floor(Math.random() * 3),
      recovered: 3 + Math.floor(Math.random() * 6),
      falsePositive: Math.floor(Math.random() * 2)
    });
  }
  const topVehicles = [
    { plateNo: '京B·90005', count: 8, mileage: 42.3 },
    { plateNo: '京A·12346', count: 5, mileage: 21.5 },
    { plateNo: '粤B·C2002', count: 4, mileage: 42.3 },
    { plateNo: '京A·12349', count: 3, mileage: 5.1 },
    { plateNo: '沪A·P1003', count: 2, mileage: 0.6 }
  ];
  const topRoutes = [
    { routeName: '北京-天津 早班通勤线', count: 16, pct: 57 },
    { routeName: '深圳市区-盐田港 冷链配送', count: 5, pct: 18 },
    { routeName: '上海虹桥-浦东机场 班车线', count: 4, pct: 14 },
    { routeName: '其他线路', count: 3, pct: 11 }
  ];
  const total = MOCK_EVENTS.length;
  const ongoing = MOCK_EVENTS.filter(e => e.eventStatus === 1).length;
  const handled = MOCK_EVENTS.filter(e => e.handleStatus === 2 || e.handleStatus === 3).length;
  const falsePositive = MOCK_EVENTS.filter(e => e.handleStatus === 4).length;
  const falsePositiveRate = total ? Math.round(falsePositive / total * 100) : 0;
  return delay({
    code: 200,
    data: {
      overview: {
        totalLast7Days: 28,
        ongoingNow: ongoing,
        handledCount: handled,
        falsePositiveCount: falsePositive,
        falsePositiveRate
      },
      trend,
      topVehicles,
      topRoutes
    }
  });
}

// 查询车辆历史行驶轨迹（模拟 QueryVehicleTrackInfo）
export function mockGetVehicleTrack({ vehicleId, startTime, endTime }) {
  const vehicle = MOCK_VEHICLES_POOL.find(v => v.vehicleId == vehicleId);
  if (!vehicle) return delay({ code: 404, msg: '车辆不存在' });

  // 根据车辆ID选择一条已有线路作为基础轨迹（模拟该车辆曾跑过该线路）
  let baseRoute = null;
  // 优先找已绑定该车辆的线路
  for (const b of MOCK_BINDINGS) {
    if (b.vehicles && b.vehicles.some(v => v.vehicleId == vehicleId)) {
      baseRoute = MOCK_ROUTES.find(r => r.id === b.routeId);
      if (baseRoute) break;
    }
  }
  // 没有则用第一条线路
  if (!baseRoute) baseRoute = MOCK_ROUTES[0];

  const baseGeom = baseRoute.geom || [];
  if (!baseGeom.length) return delay({ code: 200, data: { GpsData: [], StopData: [], EventData: [] } });

  // 生成密集GPS点：对基准线做插值，模拟每10秒一个点
  const GpsData = [];
  const startDate = startTime ? new Date(startTime) : new Date(now - 2 * 3600 * 1000);
  const endDate = endTime ? new Date(endTime) : new Date(now - 1 * 3600 * 1000);
  const totalSec = Math.max(60, (endDate - startDate) / 1000);
  const interval = 10; // 10秒一个点
  const totalPoints = Math.min(800, Math.floor(totalSec / interval));

  for (let i = 0; i < totalPoints; i++) {
    const t = i / Math.max(1, totalPoints - 1);
    // 在基准线上做线性插值
    const segIdx = Math.min(baseGeom.length - 2, Math.floor(t * (baseGeom.length - 1)));
    const segT = t * (baseGeom.length - 1) - segIdx;
    const p0 = baseGeom[segIdx];
    const p1 = baseGeom[segIdx + 1];
    const lng = p0[0] + (p1[0] - p0[0]) * segT + (Math.random() - 0.5) * 0.0008;
    const lat = p0[1] + (p1[1] - p0[1]) * segT + (Math.random() - 0.5) * 0.0008;
    const dt = new Date(startDate.getTime() + i * interval * 1000);
    const p = (n) => n.toString().padStart(2, '0');
    const speed = 20 + Math.floor(Math.random() * 60);
    GpsData.push({
      Longitude: lng,
      Latitude: lat,
      GpsDateTime: `${dt.getFullYear()}-${p(dt.getMonth()+1)}-${p(dt.getDate())} ${p(dt.getHours())}:${p(dt.getMinutes())}:${p(dt.getSeconds())}`,
      Speed: speed,
      Direction: Math.floor(Math.random() * 360),
      AccState: 1,
      Mileage: Math.floor(i * speed / 3.6 * interval / 1000 * 10) / 10,
      Position: `模拟位置点 ${i + 1}`
    });
  }

  // 停车点（取轨迹中速度<5的几个点，或随机几个）
  const StopData = [];
  for (let i = 0; i < Math.min(3, GpsData.length); i += Math.max(1, Math.floor(GpsData.length / 3))) {
    const g = GpsData[i];
    StopData.push({
      Longitude: g.Longitude,
      Latitude: g.Latitude,
      StartTime: g.GpsDateTime,
      EndTime: GpsData[Math.min(i + 5, GpsData.length - 1)].GpsDateTime,
      Duration: 50,
      Position: g.Position
    });
  }

  return delay({ code: 200, data: { GpsData, StopData, EventData: [] } });
}

export default {
  mockGetRoutes, mockGetRouteDetail, mockSaveRoute, mockDeleteRoute, mockCopyRoute, mockToggleRouteStatus,
  mockGetBindings, mockGetBindingDetail, mockSaveBinding, mockDeleteBinding, mockToggleBindingStatus, mockCheckBindingConflict,
  mockGetVehicles, mockGetVehicleGroups, mockGetVehicleTrack,
  mockGetEvents, mockGetEventDetail, mockGetEventReplay, mockHandleEvent, mockAddExemptPoint, mockGetEventStatistics
};
